document.addEventListener('DOMContentLoaded', function() {
  const emblaNode = document.querySelector('.ecs-product-recommendations .embla');
  if (!emblaNode) return;

  const emblaApi = EmblaCarousel(emblaNode, {
    align: 'start',
    loop: false,
    slidesToScroll: window.innerWidth >= 750 ? 2 : 1,
    containScroll: 'trimSnaps'
  });

  const slides = emblaApi.slideNodes();
  const dotsContainer = document.querySelector('.ecs-product-recommendations .embla__dots');
  const prevButton = document.querySelector('.ecs-product-recommendations .embla__button--prev');
  const nextButton = document.querySelector('.ecs-product-recommendations .embla__button--next');

  const setActiveClass = () => {
    const selectedIndex = emblaApi.selectedScrollSnap();
    slides.forEach((slide, index) => {
      slide.classList.toggle('active', index === selectedIndex);
    });
    updateDots(selectedIndex);
  };

  const updateDots = (selectedIndex) => {
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll('.embla__dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === selectedIndex);
    });
  };

  const toggleNavigationVisibility = (numberOfDots) => {
    if (dotsContainer) {
      dotsContainer.style.display = numberOfDots <= 1 ? 'none' : '';
    }
    if (prevButton) {
      prevButton.style.display = numberOfDots <= 1 ? 'none' : '';
    }
    if (nextButton) {
      nextButton.style.display = numberOfDots <= 1 ? 'none' : '';
    }
  };

  const createDots = () => {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = '';
    
    // Calculate number of dots based on viewport width
    let slidesPerView = 1;
    let slidesToScroll = 1;
    if (window.innerWidth >= 1000) {
      slidesPerView = 4;
      slidesToScroll = 2;
    } else if (window.innerWidth >= 750) {
      slidesPerView = 2;
      slidesToScroll = 2;
    }
    
    // Calculate number of movements needed
    const totalSlides = slides.length;
    const numberOfDots = Math.ceil((totalSlides - slidesPerView) / slidesToScroll) + 1;
    
    // Create dots based on number of movements
    for (let i = 0; i < numberOfDots; i++) {
      const dot = document.createElement('button');
      dot.classList.add('embla__dot');
      dot.setAttribute('type', 'button');
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => emblaApi.scrollTo(i * slidesToScroll));
      dotsContainer.appendChild(dot);
    }
    
    // Hide navigation if there's only one dot or fewer
    toggleNavigationVisibility(numberOfDots);
  };

  createDots();
  setActiveClass();
  emblaApi.on('select', setActiveClass);

  prevButton?.addEventListener('click', () => emblaApi.scrollPrev());
  nextButton?.addEventListener('click', () => emblaApi.scrollNext());

  // Update dots and slidesToScroll on window resize
  window.addEventListener('resize', () => {
    const slidesToScroll = window.innerWidth >= 750 ? 2 : 1;
    emblaApi.reInit({ slidesToScroll });
    createDots();
    setActiveClass();
  });
}); 